import { render, staticRenderFns } from "./agv-customer-transactions-page-content.vue?vue&type=template&id=5916b18e&scoped=true&lang=pug&"
import script from "./agv-customer-transactions-page-content.vue?vue&type=script&lang=js&"
export * from "./agv-customer-transactions-page-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916b18e",
  null
  
)

export default component.exports